import { render, staticRenderFns } from "./graficodoughnut.vue?vue&type=template&id=3fa38ae8"
import script from "./graficodoughnut.vue?vue&type=script&lang=js"
export * from "./graficodoughnut.vue?vue&type=script&lang=js"
import style0 from "./graficodoughnut.vue?vue&type=style&index=0&id=3fa38ae8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports